import { create } from 'zustand'
import notificationStore from './notification';

export default create((set, get) => ({
  collection: [],
  report: false,
  setReport(report) {
    set({ report })
  },
  async deleteReport({id}) {
    await fetch(`/api/reports/${id}`, {
      method: 'DELETE'
    })
    const newReports = [...get().collection]
    const index = newReports.findIndex(t => t.id == id)
    newReports.splice(index, 1)
    set({ collection: newReports })
    notificationStore.getState().add({
      message: `Report deleted`,
      type: 'success'
    })
  },
  fetch: async () => {
    const response = await fetch('/api/reports')
    const data = await response.json()
    set({ collection: data })
  },
}))
